<template>
  <div>
    <div class="foot_page">
            <img
        src="@/assets/img/audio_open.png"
        v-if="$store.state.audioPlay"
        class="contro_audio active right"
        @click="$store.commit('setAudioPlay',false)"
        alt
      >
      <img
        src="@/assets/img/audio_close.png"
        @click="$store.commit('setAudioPlay',true)"
        v-else
        class="contro_audio right"
        alt
      >
      <img src="@/assets/img/com_txt.png" class="result_title" alt>
      <div class="top_box">
        <div class="w100">
          <img src="@/assets/img/result_txt.png" class="lucy_txt" alt>
        </div>
        <img
          src="@/assets/img/result_share.png"
          data-name="分享"
          @click="showShare = true"
          class="result_btn"
          alt
        >
        <img
          src="@/assets/img/result_about.png"
          data-name="关于我们"
          @click="openPage"
          class="result_btn"
          alt
        >
        <div class="txt_box dis_f ali_ct fle_t">
          <div class="txt_list">奖品将于2019年6月5日抽取</div>
          <div class="txt_list">
            <span>中奖名单将公布于</span>
            <b @click="openWeb" data-name="Australian Wine 网站">Australian Wine 网站</b>
          </div>
          <div class="txt_list">敬请期待，记得关注我们哦~</div>
        </div>
        <!-- 分享弹窗 -->
        <div class="b_box dis_f ali_ct jus_ct" v-if="showShare">
          <img src="@/assets/img/share_img.png" class="share_throw" alt>
          <img
            src="@/assets/img/back_btn.png"
            data-name="返回"
            @click="$router.go(-2)"
            class="back_btn"
            alt
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showShare: false
    };
  },
  methods: {
    openPage() {
      self.location.href =
        "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA4NDI3ODMyMw==&scene=126&bizpsid=0#wechat_redirect";
    },
    openWeb() {
      self.location.href = "https://wine.koyooo.com/zh-CN/our-wines";
    }
  }
};
</script>

<style lang="scss" scoped>
.foot_page {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  background: #000;
  overflow-y: auto;
  padding-bottom: 40px;
  .result_title {
    height: 57px;
    margin: 30px 0 50px 30px;
  }
  .top_box {
    width: 641px;
    // height: 939px;
    margin: 0 auto 130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("~@/assets/img/result_bg.png") no-repeat center;
    background-size: cover;
    margin-bottom: 40px;
    .lucy_txt {
      height: 189px;
      margin-top: 90px;
      margin-bottom: 135px;
      position: relative;
      left: -10px;
    }
    .lucy_fish {
      width: 247px;
      margin: 44px 0;
    }
    .result_btn {
      width: 387px;
      margin: 0 auto 70px;
    }
    .txt_box {
      margin-bottom: -40px;
    }
    .txt_list {
      height: 55px;
      line-height: 55px;
      background-color: #ffffff;
      padding: 0 30px;
      color: #0d0000;
      font-size: 30px;
      margin-bottom: 14px;
      b {
        color: #0066ff;
        font-weight: normal;
        text-decoration: underline;
      }
    }
    .share_throw {
      position: absolute;
      top: -6%;
      right: -6%;
      width: 120%;
    }
    .back_btn {
      width: 277px;
      height: 99px;
      margin-top: 100px;
    }
  }
}
</style>
